import { createStore } from 'vuex';
import alerts from './alerts';
import back from './back';
import header from './header';

import {addResponseHandler} from '@/api/http';

const store = createStore({
	modules: {
		alerts,
        back,
        header
	},
	strict: process.env.NODE_ENV !== 'production'
});

addResponseHandler(
    function(response){
        let res = true

        if (response.data.hasOwnProperty('success') && !response.data.success) {
            store.dispatch('alerts/add', {
                text: response.data.message,
                timeout: 5000,
                critical: false
            });
            res = false
        }

        response.data = { res: res, data: response.data };

        return response;
    },
    function(error){
        let message = 'Unknown errors'

        if (error && error.hasOwnProperty('response') && error.response.hasOwnProperty('data') && error.response.data.hasOwnProperty('error')) {
            message = error.response.data.error
        }

        if (error && error.hasOwnProperty('response') && error.response.hasOwnProperty('data') && error.response.data.hasOwnProperty('message')) {
            message = error.response.data.message
        }

        store.dispatch('alerts/add', {
            text: message,
            timeout: 5000,
            critical: false
        });

        return { data: { res: false, data: null }};
    }
);

export default store;
